var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoVulnerabilities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0011 74.1873C23.0011 45.8502 46.0741 23 74.407 23C102.74 23 125.813 45.8333 125.813 74.1873C125.813 86.2159 121.644 97.2774 114.664 106.012C105.032 118.108 90.3289 125.376 74.4059 125.376C58.483 125.376 43.7604 118.063 34.1406 106.012C27.1604 97.2785 23 86.2169 23 74.1873H23.0011Z",
    fill: "url(#paint0_linear_3927_16810)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9686 114.669C29.529 113.438 28.9633 111.981 27.7269 111.423C26.4904 110.865 25.0343 111.411 24.4739 112.642C23.9135 113.873 24.4548 115.34 25.6913 115.897C26.9277 116.455 28.4082 115.899 28.9686 114.668V114.669Z",
    fill: "url(#paint1_linear_3927_16810)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6024 119.485C32.959 118.702 32.5992 117.774 31.8127 117.419C31.0263 117.064 30.0987 117.412 29.7421 118.196C29.3855 118.979 29.7304 119.913 30.5169 120.268C31.3033 120.623 32.2458 120.269 32.6024 119.486V119.485Z",
    fill: "url(#paint2_linear_3927_16810)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.865 29.5279C120.749 28.5028 120.617 26.9451 119.588 26.0648C118.558 25.1845 117.007 25.3018 116.122 26.3269C115.238 27.352 115.345 28.9108 116.374 29.7921C117.404 30.6725 118.982 30.553 119.866 29.5279H119.865Z",
    fill: "url(#paint3_linear_3927_16810)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.995 35.1649C122.558 34.5118 122.474 33.5216 121.819 32.9604C121.163 32.4003 120.176 32.4754 119.614 33.1274C119.051 33.7805 119.118 34.7718 119.774 35.333C120.43 35.8931 121.434 35.817 121.996 35.1649H121.995Z",
    fill: "url(#paint4_linear_3927_16810)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0698 34.3807C32.9539 33.3556 32.8222 31.7979 31.7928 30.9176C30.7633 30.0373 29.2116 30.1546 28.3276 31.1797C27.4435 32.2048 27.5496 33.7636 28.5791 34.6449C29.6086 35.5252 31.1868 35.4058 32.0708 34.3807H32.0698Z",
    fill: "url(#paint5_linear_3927_16810)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.486 27.0226V27H44.5143V27.0226C44.5143 32.905 39.8041 37.6788 34 37.6788V90.8691C34 99.2289 38.2191 107.012 45.184 111.503L70.5544 127.838C72.9541 129.387 76.0347 129.387 78.4345 127.838L103.816 111.503C110.781 107.023 115 99.2402 115 90.8691V37.6788C109.196 37.6788 104.486 32.905 104.486 27.0226ZM104.486 90.8691C104.486 95.609 102.131 99.9642 98.1794 102.509L74.4944 117.758V78.0071H44.5031V45.473C47.6953 43.5951 50.363 40.8915 52.2046 37.6562H74.4944V78.0071H104.486V90.8805V90.8691Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4944 78.0071V117.758L98.1794 102.509C102.131 99.9642 104.486 95.609 104.486 90.8691V90.8805V78.0071H74.4944ZM74.4944 78.0071H44.5031V45.473C47.6953 43.5951 50.363 40.8915 52.2046 37.6562H74.4944V78.0071ZM104.486 27.0226V27H44.5143V27.0226C44.5143 32.905 39.8041 37.6788 34 37.6788V90.8691C34 99.2289 38.2191 107.012 45.184 111.503L70.5544 127.838C72.9541 129.387 76.0347 129.387 78.4345 127.838L103.816 111.503C110.781 107.023 115 99.2402 115 90.8691V37.6788C109.196 37.6788 104.486 32.905 104.486 27.0226Z",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 77,
    r: 19.7,
    fill: "url(#paint6_linear_3927_16810)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 77,
    r: 14.4,
    fill: "url(#paint7_linear_3927_16810)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6569 79.4853C72.0474 79.8758 72.6806 79.8758 73.0711 79.4853L80.8493 71.7071C81.2398 71.3166 81.873 71.3166 82.2635 71.7071C82.654 72.0976 82.654 72.7308 82.2635 73.1213L73.0711 82.3137C72.6806 82.7042 72.0474 82.7042 71.6569 82.3137L66.7071 77.364C66.3166 76.9735 66.3166 76.3403 66.7071 75.9498C67.0976 75.5593 67.7308 75.5593 68.1213 75.9498L71.6569 79.4853Z",
    fill: "#5A7FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3927_16810",
    x1: 30.5,
    y1: 28.5,
    x2: 91,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3927_16810",
    x1: 26.7191,
    y1: 111.204,
    x2: 26.7191,
    y2: 116.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3927_16810",
    x1: 31.171,
    y1: 117.28,
    x2: 31.171,
    y2: 120.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3927_16810",
    x1: 117.988,
    y1: 25.4742,
    x2: 117.988,
    y2: 30.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3927_16810",
    x1: 120.801,
    y1: 32.5848,
    x2: 120.801,
    y2: 35.7081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3927_16810",
    x1: 30.1933,
    y1: 30.327,
    x2: 30.1933,
    y2: 35.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3927_16810",
    x1: 59.6,
    y1: 61.8,
    x2: 89.6,
    y2: 93.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3927_16810",
    x1: 64,
    y1: 66.2,
    x2: 82.8,
    y2: 88.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVulnerabilities);
export default __webpack_public_path__ + "static/media/no-vulnerabilities.7033c8572502c527461abe83d469973a.svg";
export { ForwardRef as ReactComponent };